import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import constants from "../../constants";
import http from "../http";
var ACADEMIC_YEARS_ENDPOINT = "".concat(constants.API_URL, "/academic-years");
var ACADEMIC_YEARS_ENDPOINT_V1 = "".concat(constants.API_URL_V1, "/academic-years");
var ACADEMIC_YEARS_ENDPOINT_V2 = "".concat(constants.API_URL_V2, "/academic-years");

function getAcademicYearCourses(_x) {
  return _getAcademicYearCourses.apply(this, arguments);
}

function _getAcademicYearCourses() {
  _getAcademicYearCourses = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref) {
    var academicYearId, params, response;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            academicYearId = _ref.academicYearId, params = _ref.params;
            _context5.next = 3;
            return http.get("".concat(ACADEMIC_YEARS_ENDPOINT, "/").concat(academicYearId, "/courses"), {
              params: params
            });

          case 3:
            response = _context5.sent;
            return _context5.abrupt("return", response);

          case 5:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _getAcademicYearCourses.apply(this, arguments);
}

function getClasses(_x2) {
  return _getClasses.apply(this, arguments);
}

function _getClasses() {
  _getClasses = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref2) {
    var academicYearId, response;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            academicYearId = _ref2.academicYearId;
            _context6.next = 3;
            return http.get("".concat(ACADEMIC_YEARS_ENDPOINT_V1, "/").concat(academicYearId, "/classes"));

          case 3:
            response = _context6.sent;
            return _context6.abrupt("return", response);

          case 5:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _getClasses.apply(this, arguments);
}

function importStudents(_x3) {
  return _importStudents.apply(this, arguments);
}

function _importStudents() {
  _importStudents = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref3) {
    var academicYearId, data, onUploadProgress, response;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            academicYearId = _ref3.academicYearId, data = _ref3.data, onUploadProgress = _ref3.onUploadProgress;
            _context7.next = 3;
            return http.post("".concat(ACADEMIC_YEARS_ENDPOINT, "/").concat(academicYearId, "/students/import"), data, {
              onUploadProgress: onUploadProgress
            });

          case 3:
            response = _context7.sent;
            return _context7.abrupt("return", response);

          case 5:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _importStudents.apply(this, arguments);
}

function exportStudents(_x4) {
  return _exportStudents.apply(this, arguments);
}

function _exportStudents() {
  _exportStudents = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_ref4) {
    var academicYearId, stage, response;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            academicYearId = _ref4.academicYearId, stage = _ref4.stage;
            _context8.next = 3;
            return http.get("".concat(ACADEMIC_YEARS_ENDPOINT, "/").concat(academicYearId, "/students/csv").concat(stage ? "?stageId=".concat(stage) : ""));

          case 3:
            response = _context8.sent;
            return _context8.abrupt("return", response);

          case 5:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _exportStudents.apply(this, arguments);
}

var exportPrincipalsScores = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref5) {
    var academicYearId, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            academicYearId = _ref5.academicYearId;
            _context.next = 3;
            return http.get("".concat(ACADEMIC_YEARS_ENDPOINT, "/").concat(academicYearId, "/principals/score-csv"));

          case 3:
            response = _context.sent;
            return _context.abrupt("return", response);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function exportPrincipalsScores(_x5) {
    return _ref6.apply(this, arguments);
  };
}();

var exportHODsScores = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref7) {
    var academicYearId, response;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            academicYearId = _ref7.academicYearId;
            _context2.next = 3;
            return http.get("".concat(ACADEMIC_YEARS_ENDPOINT, "/").concat(academicYearId, "/hods/score-csv"));

          case 3:
            response = _context2.sent;
            return _context2.abrupt("return", response);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function exportHODsScores(_x6) {
    return _ref8.apply(this, arguments);
  };
}();

function getAcademicYear(_x7) {
  return _getAcademicYear.apply(this, arguments);
}

function _getAcademicYear() {
  _getAcademicYear = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(academicYearId) {
    var response;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return http.get("".concat(ACADEMIC_YEARS_ENDPOINT, "/").concat(academicYearId));

          case 2:
            response = _context9.sent;
            return _context9.abrupt("return", response);

          case 4:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _getAcademicYear.apply(this, arguments);
}

function deleteAcademicYear(_x8) {
  return _deleteAcademicYear.apply(this, arguments);
}

function _deleteAcademicYear() {
  _deleteAcademicYear = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(academicYearId) {
    var response;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.next = 2;
            return http["delete"]("".concat(ACADEMIC_YEARS_ENDPOINT, "/").concat(academicYearId));

          case 2:
            response = _context10.sent;
            return _context10.abrupt("return", response);

          case 4:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
  return _deleteAcademicYear.apply(this, arguments);
}

function importCourses(_x9) {
  return _importCourses.apply(this, arguments);
}

function _importCourses() {
  _importCourses = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(_ref9) {
    var academicYearId, data, onUploadProgress, response;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            academicYearId = _ref9.academicYearId, data = _ref9.data, onUploadProgress = _ref9.onUploadProgress;
            _context11.next = 3;
            return http.post("".concat(constants.API_URL, "/academic-years/").concat(academicYearId, "/courses/import"), data, {
              onUploadProgress: onUploadProgress
            });

          case 3:
            response = _context11.sent;
            return _context11.abrupt("return", response);

          case 5:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
  return _importCourses.apply(this, arguments);
}

function exportCourses(_x10) {
  return _exportCourses.apply(this, arguments);
}

function _exportCourses() {
  _exportCourses = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(_ref10) {
    var academicYearId, response;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            academicYearId = _ref10.academicYearId;
            _context12.next = 3;
            return http.get("".concat(constants.API_URL, "/academic-years/").concat(academicYearId, "/courses/csv"));

          case 3:
            response = _context12.sent;
            return _context12.abrupt("return", response);

          case 5:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));
  return _exportCourses.apply(this, arguments);
}

function yearUrl(id) {
  return "".concat(ACADEMIC_YEARS_ENDPOINT, "/").concat(id);
}

function createItem(_x11) {
  return _createItem.apply(this, arguments);
}

function _createItem() {
  _createItem = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(_ref11) {
    var academicYearId, data, response;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            academicYearId = _ref11.academicYearId, data = _ref11.data;
            _context13.next = 3;
            return http.post("".concat(yearUrl(academicYearId), "/classes"), data);

          case 3:
            response = _context13.sent;
            return _context13.abrupt("return", response);

          case 5:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));
  return _createItem.apply(this, arguments);
}

function importClasses(_x12) {
  return _importClasses.apply(this, arguments);
}

function _importClasses() {
  _importClasses = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(_ref12) {
    var academicYearId, data, onUploadProgress, response;
    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            academicYearId = _ref12.academicYearId, data = _ref12.data, onUploadProgress = _ref12.onUploadProgress;
            _context14.next = 3;
            return http.post("".concat(yearUrl(academicYearId), "/classes/import"), data, {
              onUploadProgress: onUploadProgress
            });

          case 3:
            response = _context14.sent;
            return _context14.abrupt("return", response);

          case 5:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));
  return _importClasses.apply(this, arguments);
}

function exportClasses(_x13) {
  return _exportClasses.apply(this, arguments);
}

function _exportClasses() {
  _exportClasses = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(_ref13) {
    var academicYearId, response;
    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            academicYearId = _ref13.academicYearId;
            _context15.next = 3;
            return http.get("".concat(yearUrl(academicYearId), "/classes/csv"));

          case 3:
            response = _context15.sent;
            return _context15.abrupt("return", response);

          case 5:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));
  return _exportClasses.apply(this, arguments);
}

function getStages(_x14) {
  return _getStages.apply(this, arguments);
}

function _getStages() {
  _getStages = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(_ref14) {
    var academicYearId, response;
    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            academicYearId = _ref14.academicYearId;
            _context16.next = 3;
            return http.get("".concat(ACADEMIC_YEARS_ENDPOINT, "/").concat(academicYearId, "/stages"));

          case 3:
            response = _context16.sent;
            return _context16.abrupt("return", response);

          case 5:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16);
  }));
  return _getStages.apply(this, arguments);
}

var downloadAllCalendars = /*#__PURE__*/function () {
  var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref15) {
    var academicYearId, params, onDownloadProgress, response;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            academicYearId = _ref15.academicYearId, params = _ref15.params, onDownloadProgress = _ref15.onDownloadProgress;
            _context3.next = 3;
            return http.get("".concat(ACADEMIC_YEARS_ENDPOINT, "/").concat(academicYearId, "/calendars/download-all"), {
              params: params,
              responseType: "arraybuffer",
              onDownloadProgress: onDownloadProgress
            });

          case 3:
            response = _context3.sent;
            return _context3.abrupt("return", response);

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function downloadAllCalendars(_x15) {
    return _ref16.apply(this, arguments);
  };
}();

var getAcademicYearClasses = /*#__PURE__*/function () {
  var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref17) {
    var academicYearId, params, response;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            academicYearId = _ref17.academicYearId, params = _ref17.params;
            _context4.next = 3;
            return http.get("".concat(ACADEMIC_YEARS_ENDPOINT_V2, "/").concat(academicYearId, "/classes"), {
              params: params
            });

          case 3:
            response = _context4.sent;
            return _context4.abrupt("return", response);

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function getAcademicYearClasses(_x16) {
    return _ref18.apply(this, arguments);
  };
}();

export default {
  getAcademicYearCourses: getAcademicYearCourses,
  getClasses: getClasses,
  importStudents: importStudents,
  exportStudents: exportStudents,
  exportPrincipalsScores: exportPrincipalsScores,
  exportHODsScores: exportHODsScores,
  getAcademicYear: getAcademicYear,
  deleteAcademicYear: deleteAcademicYear,
  importCourses: importCourses,
  exportCourses: exportCourses,
  createItem: createItem,
  importClasses: importClasses,
  exportClasses: exportClasses,
  getStages: getStages,
  downloadAllCalendars: downloadAllCalendars,
  getAcademicYearClasses: getAcademicYearClasses
};